const ACTION_TYPES = {
    UPDATE_ORDER: 'UPDATE_ORDER',
    SUBMITTED_ORDER: 'SUBMITTED_ORDER',
    TOGGLE_PLACE_ORDER: 'TOGGLE_PLACE_ORDER',
    ORDER_ERRORS: 'ORDER_ERRORS',
    SECTION_SAVED: 'SECTION_SAVED',
    PAYMENT_CARD_NUMBER_CHANGED: 'PAYMENT_CARD_NUMBER_CHANGED',
    PAYMENT_CARDS_DETECTED: 'PAYMENT_CARDS_DETECTED',
    UPDATE_SHIPPING_METHODS: 'UPDATE_SHIPPING_METHODS',
    VALIDATE_ADDRESS: 'VALIDATE_ADDRESS',
    ORDER_REVIEW_TOGGLE: 'ORDER_REVIEW_TOGGLE',
    TOGGLE_CVC_INFO_MODAL: 'TOGGLE_CVC_INFO_MODAL',
    SET_PLACE_ORDER_PRE_HOOK: 'SET_PLACE_ORDER_PRE_HOOK',
    GIFT_CARD_APPLIED: 'GIFT_CARD_APPLIED'
};

let initialState = {
    orderDetails: {
        isInitialized: false,
        header: { profile: { user: {} } },
        items: { items: [] },
        priceInfo: {},
        shippingGroups: { shippingGroupsEntries: [] },
        paymentGroups: { paymentGroupsEntries: [] }
    },
    editOrderData: {},
    giftWrapOptions: {},
    orderShippingMethods: {},
    addressList: [],
    paymentOptions: {},
    isApplePayFlow: false
};
/**
 * If removing property from basket state, don't remove property entirely.
 * If you do, state will not reflect change due to object.assign.
 * Instead set property value to null to simulate removal, this will update state.
 */
const reducer = function (state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.UPDATE_ORDER: {
            let { orderDetails = {} } = action;
            return Object.assign({}, state, {
                orderDetails: Object.assign({}, orderDetails, {
                    isInitialized: state.orderDetails.isInitialized || orderDetails.isInitialized
                })
            });
        }
        case ACTION_TYPES.SUBMITTED_ORDER:
            return Object.assign({}, state, { submittedDetails: action.submittedDetails });
        case ACTION_TYPES.TOGGLE_PLACE_ORDER:
            return Object.assign({}, state, { isPlaceOrderDisabled: action.isPlaceOrderDisabled });
        case ACTION_TYPES.UPDATE_SHIPPING_METHODS: {
            let orderShippingMethods = Object.assign({}, state.orderShippingMethods);
            orderShippingMethods[action.shippingGroup] = action.shippingMethods;
            return Object.assign({}, state, { orderShippingMethods: orderShippingMethods });
        }
        case ACTION_TYPES.VALIDATE_ADDRESS: {
            return Object.assign({}, state, { addressData: action.addressId });
        }
        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
